import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: null,
    hideLine: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  // 是否隐藏线条
  hideLine?: boolean;
}



return { __sfc: true,props }
}

})